import React from 'react';
import { Link } from "react-router-dom";
import * as util from "../../other/util.js";

// A list with an overview of all planets of the player
export default class PlanetListView extends React.Component {

    createProjectBox(project, url) {
        if (!project) {
            return (<div className="project-box-none" />);
        }

        if (project.active || (project.queue != null && project.queue.length >= 1)) {
            return (<Link to={{ pathname: url, force_update: true }}>
                <div className="project-box-active" />
            </Link>);
        } else {
            return (<Link to={{ pathname: url, force_update: true }}>
                <div className="project-box-idle" />
            </Link>);
        }
    }

    renderPlanet(planet) {
        let planet_url = util.getPlanetUrl(planet);

        return (
            <tr key={planet.key}>
                <td style={{ width: "30%" }}>
                    <util.PlanetLink planet={planet} linkToDetails={true} />
                </td>
                <td style={{ width: "12%" }}>{this.createProjectBox(planet.building_project, "/game/planet-construction" + planet_url)}</td>
                <td style={{ width: "12%" }}>{this.createProjectBox(planet.ship_construction_project, "/game/planet-ship-construction" + planet_url)}</td>
                <td style={{ width: "12%" }}>{this.createProjectBox(planet.ship_design_project, "/game/planet-ship-design" + planet_url)}</td>
                <td style={{ width: "12%" }}><Link className="link-button" to={{ pathname: '/game/planet-ships' + planet_url }}>{planet.ship_count}</Link></td>
                <td className="numbers" style={{ width: "10%" }}>{planet.points}</td>
            </tr>
        );
    }

    render() {
        let planets = this.props.planets;

        if (planets.length === 0) {
            return (<div />);
        }

        let html = planets.map((planet) => {
            return this.renderPlanet(planet);
        });

        return (
            <div>
                <h2>Planet Overview</h2>
                <table className="generic-list">
                    <thead style={{ fontSize: "14px" }}>
                        <tr>
                            <td />
                            <td>Construction</td>
                            <td>Ship Construction</td>
                            <td>Ship Design</td>
                            <td>Ships</td>
                            <td>Points</td>
                        </tr>
                    </thead>
                    <tbody>
                        {html}
                    </tbody>
                </table>
            </div>
        );
    }
}
